import {createAction} from '@reduxjs/toolkit';
import React, {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {unsubscribe} from './api/Unsubscribe';
import {resetUserState, setLoading} from './features/user/userSlice';
import {MAX_DATE} from './Utility/constants';

const SubExpired = props => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const subscriptionsAvailable = useSelector(state => state?.app?.subscriptionsAvailable);
  const {
    hasActiveSub,
    hasExistingSub,
    currentSubDetails,
    existingSubDetails,
    userName,
    password,
    token,
    isLoading,
  } = useSelector(state => state.user);
  const expiringBy = new Date(currentSubDetails?.PeriodEnd).toLocaleDateString();

  const handleNavToPayment = useCallback(
    PaymentService => {
      navigate('/payment', {state: {subscriptionType: PaymentService}});
    },
    [navigate],
  );

  const handleUnsubscribe = useCallback(subId => {
    dispatch(setLoading(true));
    //console.log(userName);
    unsubscribe(userName, navigate, subId, token);
  }, []);

  const handleSignOut = () => {
    window.localStorage.clear();
    dispatch(resetUserState());
    //dispatch logout
    navigate('/');
  };

  const renderSubItems = () => {
    if (subscriptionsAvailable) {
      return subscriptionsAvailable?.map(subItem => {
        return (
          <div className="col" key={subItem?.SubscriptionCode}>
            <div className="card mb-3 box-shadow">
              <div className="card-header text-bg-primary">
                <h4 className="my-0 font-weight-normal">
                  {subItem?.PaymentService?.toUpperCase()}
                </h4>
              </div>
              <div className="card-body">
                {subItem.PaymentService === 'paylux' ? (
                  <h1 className="card-title pricing-card-title">
                    ${subItem?.Price} <small className="text-muted">/ mo</small>
                  </h1>
                ) : (
                  <h1 className="card-title pricing-card-title">
                    <small className="text-muted">_</small>
                  </h1>
                )}

                <ul className="list-unstyled mt-3 mb-4">
                  <li>{subItem?.Description}</li>
                </ul>
                <button
                  type="button"
                  className="btn btn-md btn-block btn-primary"
                  onClick={() => handleNavToPayment(subItem?.PaymentService)}
                >
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        );
      });
    }
  };

  const renderCurrentProduct = () => {
    if (hasActiveSub) {
      return (
        <div className="col">
          <div className="card mb-3 box-shadow" key={hasActiveSub}>
            <div className="card-header text-bg-primary">
              <h4 className="my-0 font-weight-normal">{'Top Opportunities'}</h4>
            </div>
            <div className="card-body">
              <h1 className="card-title pricing-card-title">
                <small className="text-muted">
                  Currently subscribed to {currentSubDetails?.PaymentService.toUpperCase()}
                </small>
              </h1>
              <ul className="list-unstyled mt-3 mb-4">
                <li className="mb-2">{currentSubDetails?.Description}</li>
                <li className="mb-2">
                  <strong>
                    {expiringBy === MAX_DATE ? null : `Subscription expiring on ${expiringBy}`}
                  </strong>
                </li>
              </ul>
              {isLoading ? (
                <button disabled className="btn btn-md btn-block btn-primary mx-2">
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Loading...
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-md btn-block btn-primary mx-2"
                  onClick={() => handleUnsubscribe(currentSubDetails?.SubscriptionId)}
                >
                  Unsubscribe
                </button>
              )}
              <button
                type="button"
                className="btn btn-md btn-block btn-dark"
                onClick={() => navigate('/toplist')}
              >
                Go to TopList
              </button>
            </div>
          </div>
        </div>
      );
    }
  };
  const renderExistingSub = () => {
    if (hasExistingSub) {
      return existingSubDetails?.map((sub, idx) => {
        const expiringExistingBy = new Date(sub?.PeriodEnd).toLocaleDateString();
        return (
          <div className="col" key={hasExistingSub + idx}>
            <div className="card mb-3 box-shadow">
              <div className="card-header text-bg-primary">
                <h4 className="my-0 font-weight-normal">{'Existing subscription'}</h4>
              </div>
              <div className="card-body">
                <ul className="list-unstyled mt-3 mb-4">
                  <li className="mb-2">{sub?.Description}</li>
                  <li className="mb-2">
                    <strong>
                      {expiringExistingBy === MAX_DATE
                        ? null
                        : `Subscription expiring on ${expiringExistingBy}`}
                    </strong>
                  </li>
                </ul>
                <button
                  type="button"
                  className="btn btn-md btn-block btn-dark"
                  onClick={() => navigate('/toplist')}
                >
                  Go to TopList
                </button>
              </div>
            </div>
          </div>
        );
      });
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-end p-3">
        <button type="button" className="btn btn-md btn-danger" onClick={handleSignOut}>
          Sign Out
        </button>
      </div>
      <div className="pricing-header px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
        <h1 className="display-4">{hasActiveSub ? '' : 'No active subscriptions!'}</h1>
        <p className="lead">
          Pilot's algorithm scans the market in real time and learns what other traders are doing,
          tracks their behaviour, and notifies you when prime trading opportunities are taking place
          on Stocks, Forex, Futures and Crypto on whatever brokerage or exchange you are trading.
          <strong> Subscribe with below plans to keep using Pilot Lite.</strong>
        </p>
      </div>
      <div className="container">
        <div className="row row-cols-1 row-cols-md-2 g-4 text-center">
          {renderExistingSub()}
          {renderCurrentProduct()}
          {renderSubItems()}
        </div>
      </div>
    </div>
  );
};

export default SubExpired;
